module.exports = __webpack_public_path__ + "static/media/blog-featured-episode.c73812df.png";